import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import {
  CropRotation,
  CropRotationAdviceResponse,
  CropRotationEntry,
} from './crop-rotation.model';

@Injectable({
  providedIn: 'root',
})
export class CropRotationService {
  private readonly http = inject(HttpClient);

  getCropRotations(
    farmId?: number,
  ) {
    let params = new HttpParams();

    if (farmId !== undefined) {
      params = params.set(
        'farmId',
        farmId,
      );
    }

    return this.http.get<CropRotation[]>(
      `${environment.apiUrl}/crop-rotations`,
      {
        params,
      },
    );
  }

  getAdvice(
    fieldId: number,
    period: number,
  ) {
    return this.http.get<CropRotationAdviceResponse>(
      `${environment.apiUrl}/crop-rotations/${fieldId}/advice/${period}`,
    );
  }

  saveCropRotation(
    fieldId: number,
    period: number,
    crop: string,
  ) {
    return this.http.put<CropRotationEntry>(
      `${environment.apiUrl}/crop-rotations/${fieldId}/${period}`,
      {
        crop,
      },
    );
  }
}
